import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import React from 'react';
import { useTranslation } from 'react-i18next';
import brain from '@/assets/images/brain-doesnt-know.png';
import heart from '@/assets/images/heart-muscles.png';
import { SectionHeadline } from '@/components/SectionHeadline';
import { ContentContainer } from '@/components/layout';
import { Button } from '@/components/buttons';
import { LINKS } from '@/constants/links';
import BrainPointingImage from '@/assets/images/brain-pointing-right.png';
import HeartPointingImage from '@/assets/images/heart-pointing-left.png';
export function Discover() {
  const $ = _c(23);
  const {
    t
  } = useTranslation("gcss");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="4xl:w-auto absolute top-14 left-0 hidden w-80 lg:block"><Image src={HeartPointingImage} width={416} height={320} alt="" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="4xl:w-auto absolute top-14 right-0 hidden w-80 lg:block"><Image src={BrainPointingImage} width={370} height={320} alt="" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("discover.title");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <SectionHeadline className="mb-4 whitespace-nowrap lg:mb-6" anchorKey="discover.title">{t2}</SectionHeadline>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("discover.text");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <p className="mb-10 px-4 text-center text-sm lg:mb-12 lg:px-0 lg:text-base">{t4}</p>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = LINKS();
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = t6.rewards;
  let t8;
  if ($[11] !== t) {
    t8 = t("discover.cta");
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <Button variant="primary" testId="discover" analyticsParam="discover" to={t7} size="lg" align="center" className="mb-10 lg:mb-0">{t8}</Button>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t3 || $[16] !== t5 || $[17] !== t9) {
    t10 = <div className="md:order-2 md:w-1/2 lg:w-full lg:max-w-148">{t3}{t5}{t9}</div>;
    $[15] = t3;
    $[16] = t5;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="w-1/2 pl-4 md:order-1 md:p-4 lg:hidden"><Image src={brain} alt="" width={384} /></div>;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="w-1/2 pr-4 md:order-3 md:p-4 lg:hidden"><Image src={heart} alt="" width={360} /></div>;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t10) {
    t13 = <div className="relative bg-blue-50 pt-20 pb-8 lg:pb-28">{t0}{t1}<ContentContainer><div className="flex flex-row flex-wrap items-center justify-center md:flex-nowrap">{t10}{t11}{t12}</div></ContentContainer></div>;
    $[21] = t10;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
}